var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMapinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 300 300"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#4A90E2",
    cx: 166.923,
    cy: 150,
    r: 115.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M45.052 96.606L97.918 76.78v150.553L45.052 247.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M218.753 227.334l-52.866 19.825V96.606l52.866-19.825z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.207 67.794a3.776 3.776 0 013.474.453 3.776 3.776 0 011.617 2.88l.007.217V229.94a3.776 3.776 0 01-2.306 3.326l-.186.072-59.99 22.625a3.76 3.76 0 01-1.712.41 3.783 3.783 0 01-1.321-.227l-59.103-22.164-59.09 22.164a3.779 3.779 0 01-1.051.22l-.27.007a3.776 3.776 0 01-3.771-3.582l-.005-.195V94a3.776 3.776 0 012.306-3.326l.186-.072 60.022-22.638a3.776 3.776 0 013.001-.17l59.102 22.164 59.09-22.164zm-123.29 8.987L45.053 96.606v150.553l52.866-19.825V76.781zm120.836 0l-52.866 19.825v150.553l52.866-19.825V76.781zm-113.283 0v150.553l52.865 19.825V96.606L105.47 76.78z",
    fill: "#000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C5DFF7",
    fillRule: "nonzero",
    d: "M105.47 227.334l52.865 19.825V96.606L105.47 76.78z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.094 173.307l.235.033.247.05.103.027.137.04.2.068 59.095 22.16 28.888-10.832a3.788 3.788 0 112.643 7.1l-30.16 11.31a3.758 3.758 0 01-.607.173l-.268.043-.217.02-.083.005-.196.003a3.926 3.926 0 01-.24-.005l.24.005a3.847 3.847 0 01-.317-.01l-.236-.026a3.664 3.664 0 01-.34-.062l-.177-.047a3.449 3.449 0 01-.301-.1l-59.047-22.142-28.886 10.832a3.78 3.78 0 01-1.322.227 3.776 3.776 0 01-1.322-7.326l30.21-11.328.112-.04.277-.082.187-.043.22-.037.12-.015c.27-.03.54-.03.805 0zM192.32 127.985c-12.41 0-22.512 9.983-22.656 22.392 0 20.844 20.24 30.21 21.108 30.662l1.548.718 1.548-.718c.869-.377 21.109-9.818 21.109-30.662-.145-12.41-10.247-22.393-22.657-22.392zm0 45.313c-4.116-2.34-15.104-9.893-15.104-22.958 0-8.342 6.762-15.105 15.104-15.105 8.342 0 15.105 6.763 15.105 15.105 0 13.178-10.913 20.655-15.105 22.958z",
    fill: "#000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.32 135.537c-8.24-.001-14.96 6.602-15.104 14.84 0 13.066 10.988 20.618 15.104 22.959 4.192-2.341 15.105-9.818 15.105-22.959-.145-8.238-6.865-14.841-15.105-14.84zm0 22.317a7.552 7.552 0 11.015-15.104 7.552 7.552 0 01-.015 15.104z",
    fill: "#8CC0F0",
    fillRule: "nonzero",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.485 180.85a3.776 3.776 0 01-3.776-3.776v-18.88a3.776 3.776 0 117.552 0v18.88a3.776 3.776 0 01-3.776 3.776z",
    fill: "#000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.485 131.761a15.105 15.105 0 00-3.776 29.718 14.765 14.765 0 007.552 0 15.104 15.104 0 00-3.776-29.718zm0 22.657a7.552 7.552 0 110-15.105 7.552 7.552 0 010 15.105z",
    fill: "#000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8CC0F0",
    fillRule: "nonzero",
    opacity: 0.5,
    cx: 71.485,
    cy: 146.865,
    r: 7.552
  }))));
}

export default SvgMapinline;